var Base = require('_js/base'),
  ko = require('knockout');

var model = function(params) {
  this.params = params;
};

function CourseRegistrationOverview() {
  this.init();
}

CourseRegistrationOverview.prototype = new Base();

CourseRegistrationOverview.prototype.init = function() {
  var $courseRegistrationOverview = $('[data-course-registration-overview]');
  if ($courseRegistrationOverview.get(0) !== undefined) {
    ko.applyBindings(
      new model({
        element: $courseRegistrationOverview.data(
          'course-registration-overview'
        )
      }),
      $courseRegistrationOverview.get(0)
    );
  }
};

module.exports = CourseRegistrationOverview;
